import React from 'react';
import { useLocation } from 'react-router-dom';
import { trackCTAClick } from '../../utils/analytics';
import { MASTERCLASS } from '../../config/masterclass';

const MobileCTA = () => {
  const location = useLocation();

  if (location.pathname.includes('/apply') || location.pathname.includes('/success') || location.pathname.includes('/booking') || location.pathname.includes('/masterclass-confirmed')) {
    return null;
  }

  const onClick = () => {
    trackCTAClick('Mobile Sticky CTA · Secure My Spot');
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-4" style={{ background: 'rgba(6,10,18,0.95)', backdropFilter: 'blur(12px)', borderTop: '1px solid rgba(201,168,76,0.15)' }}>
      <a
        href={MASTERCLASS.registrationUrl}
        onClick={onClick}
        data-testid="mobile-sticky-cta"
        className="ofs-btn w-full justify-center"
      >
        Secure My Spot
      </a>
    </div>
  );
};

export default MobileCTA;
